module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-8.20a44a22.png";